module.exports = __webpack_public_path__ + "static/media/104cc9a5-4e9a-40ce-9a68-e0b11b800415.0ae6382a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/certificate-img/competence/104cc9a5-4e9a-40ce-9a68-e0b11b800415.png
// module id = 1460
// module chunks = 0